import { useQuery } from '@tanstack/react-query';
import { Background, Package } from '../models';
import QueryKeys from '../utils/QueryKeys';

export default function useBackgrounds(packageId, selectExtra = []) {
  const backgroundScope = Background.selectExtra(selectExtra);
  return useQuery([QueryKeys.BACKGROUNDS, packageId], () => (
    Package
      .includes([{ backgroundSet: ['backgrounds'] }])
      .merge({ backgrounds: backgroundScope })
      .find(packageId)
      .then((res) => {
        if (!res.data.backgroundSet) {
          return [];
        }

        return res.data.backgroundSet.backgrounds;
      })
  ), { placeholderData: [], enabled: !!packageId });
}
